
import { defineComponent } from 'vue'
import { GetterTypes as FolderGetters, getters as folderGetters } from '@/store/modules/folders/folders.getters'
import { UISharedFolderModel } from '@/store/modules/folders/folders.model'
import head from 'lodash/head'
import FoldersList from '../components/FoldersList.vue'

export default defineComponent({
  name: 'Company',
  components: {
    FoldersList
  },
  props: ['id'],
  computed: {
    folders(): Array<UISharedFolderModel> {
      return folderGetters[FolderGetters.GET_COMPANY_FOLDERS](this.$store.state.folders)(this.$route.params.companyId)
    },
    companyName(): string {
      const folder = head(this.folders)
      return folder?.company?.name || ''
    },
    foldersLoading(): boolean {
      return this.$store.state.folders.loading
    }
  }
})
